var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0 pa-0"},[_c('router-view'),_c('notifications',{attrs:{"group":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }